import { AbstractTagSequence } from 'iframe/ts/player/controller/sequence/abstract/AbstractTagSequence';
import { getContextMetadata, getParamsFromDOM, paramsAD, utagDataProcessor } from 'iframe/ts/player/controller/sequence/utilities/TagSequenceUtilities';
import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { EmbedContext } from 'tag/ts/tag/model/enums/EmbedContext';
export class TagSequenceMVP extends AbstractTagSequence {
    #utagDataRequestTimeoutId;
    #utagDataRequestIntervalId;
    #UTAG_DATA_REQUEST_TIMEOUT = 5000;
    #UTAG_DATA_REQUEST_INTERVAL = 500;
    #UTAG_DATA_REQUEST_MAX_ATTEMPTS = 5;
    #utag_data_request_attempts = 0;
    #domParams;
    constructor(iframePlayer) {
        super(iframePlayer, 'TagSequenceMVP');
        this.appEventsHandler(this.#onAppEvent, [
            IFramePlayerEvent.ON_DOM_READ_PARAMS_REQUEST,
            IFramePlayerEvent.ON_DOM_READ_PARAMS_SUCCESS,
            IFramePlayerEvent.ON_MVP_PARENT_UTAG_DATA_RECEIVED,
            IFramePlayerEvent.ON_SMART_TAG_READY_CALLBACK,
            IFramePlayerEvent.ON_TAG_CREATE_REQUEST,
            IFramePlayerEvent.ON_TAG_CREATE_SUCCESS,
            IFramePlayerEvent.ON_UTAG_IMPORT_SUCCESS,
            IFramePlayerEvent.ON_VIDEO_LOAD_REQUEST
        ]);
    }
    #onParentUtagDataReceived = (utagData) => {
        this.#clearUtagDataRequestInterval();
        this.#clearUtagDataRequestTimeout();
        if (!this.utils.Type.isEmpty(utagData)) {
            window.utag_data = utagDataProcessor({
                utagData: this.utils.Object.cloneForPostMessage(utagData),
                apiMetadata: this.iframePlayer.model.apiMetadata,
                scripted: false
            });
            this.utils.Delay.delay().then(() => {
                this.dispatchIFramePlayerEvent({
                    type: IFramePlayerEvent.ON_UTAG_IMPORT_REQUEST,
                    target: this,
                    targetName: this.name
                });
            });
        }
    };
    #onDomReadParamsSuccess = (paramsVO) => {
        this.#domParams = paramsVO;
        this.#requestUtagData();
    };
    #requestUtagData = () => {
        const executeUtagDataRequest = () => {
            this.#utag_data_request_attempts++;
            this?.logger?.log('executeUtagDataRequest:', 'attempt:', this.#utag_data_request_attempts);
            if (this.#utag_data_request_attempts >= this.#UTAG_DATA_REQUEST_MAX_ATTEMPTS) {
                this.#clearUtagDataRequestInterval();
            }
            this.dispatchIFramePlayerEvent({
                type: IFramePlayerEvent.ON_UTAG_DATA_REQUEST_FROM_IFRAME,
                target: this,
                targetName: this.name
            });
        };
        this.#utagDataRequestIntervalId = setInterval(executeUtagDataRequest, this.#UTAG_DATA_REQUEST_INTERVAL);
        this.#utagDataRequestTimeoutId = setTimeout(this.#onUtagImportSuccess, this.#UTAG_DATA_REQUEST_TIMEOUT, 'Timeout');
    };
    #clearUtagDataRequestInterval = () => {
        clearInterval(this.#utagDataRequestIntervalId);
        this?.logger?.log('cleatUtagDataRequestInterval:', 'attempts:', this.#utag_data_request_attempts);
    };
    #clearUtagDataRequestTimeout = () => {
        clearTimeout(this.#utagDataRequestTimeoutId);
        this?.logger?.log('clearUtagDataRequestTimeout:', 'attempts:', this.#utag_data_request_attempts);
    };
    #onTagCreateRequest = () => {
        this.createTag(EmbedContext.IFRAME_MVP).then((data) => {
            this?.logger?.log('onTagCreateRequest:', 'Tag created:', data);
        });
    };
    #onTagCreateSuccess = () => {
        this.dispatchIFramePlayerEvent({
            type: IFramePlayerEvent.ON_VIDEO_LOAD_REQUEST,
            data: {
                paramsVO: this.#domParams
            },
            target: this,
            targetName: this.name
        });
    };
    #onVideoLoadRequest = (paramsVO = undefined) => {
        if (this.utils.Type.isEmpty(paramsVO?.CONTEXT)) {
            paramsVO.CONTEXT = {
                metadata: undefined
            };
        }
        paramsAD({ adParams: this.tag.params.AD, utagData: window.utag_data, scripted: false }).then((data) => {
            this.tag.params.AD = this.utils.DeepMerge.deepmerge(this.tag.params.AD, data.adParams);
            getContextMetadata(paramsVO, this.iframePlayer.model.apiMetadata).then((data) => {
                this.tag.API.VIDEO.load({
                    CONTENT: this.utils.DeepMerge.deepmerge({}, paramsVO?.CONTENT),
                    CONTEXT: {
                        metadata: data?.contextMetadata
                    }
                });
            });
        });
    };
    #onUtagImportSuccess = (origin) => {
        this.#clearUtagDataRequestTimeout();
        this?.logger?.log('continueAfterParentUtagDataRequest:', 'triggered by:', origin);
        this.dispatchIFramePlayerEvent({
            type: IFramePlayerEvent.ON_TAG_CREATE_REQUEST,
            target: this,
            targetName: this.name
        });
    };
    #onSmartTagOnReadyCallback = () => {
        this.dispatchIFramePlayerEvent({
            type: IFramePlayerEvent.ON_DOM_READ_PARAMS_REQUEST,
            target: this,
            targetName: this.name
        });
    };
    #onAppEvent = (event) => {
        this?.logger?.log('onAppEvent:', event?.type, event);
        switch (event?.type) {
            case IFramePlayerEvent.ON_SMART_TAG_READY_CALLBACK:
                this.#onSmartTagOnReadyCallback();
                break;
            case IFramePlayerEvent.ON_TAG_CREATE_REQUEST:
                this.#onTagCreateRequest();
                break;
            case IFramePlayerEvent.ON_TAG_CREATE_SUCCESS:
                this.#onTagCreateSuccess();
                break;
            case IFramePlayerEvent.ON_MVP_PARENT_UTAG_DATA_RECEIVED:
                this.#onParentUtagDataReceived(event?.data?.utagData);
                break;
            case IFramePlayerEvent.ON_UTAG_IMPORT_SUCCESS:
                this.#onUtagImportSuccess(event?.type);
                break;
            case IFramePlayerEvent.ON_DOM_READ_PARAMS_REQUEST:
                getParamsFromDOM(this).catch((error) => {
                    this?.logger?.log('onAppEvent:', event?.type, event, 'DOM params read failure:', error);
                });
                break;
            case IFramePlayerEvent.ON_DOM_READ_PARAMS_SUCCESS:
                this.#onDomReadParamsSuccess(event?.data?.paramsVO);
                break;
            case IFramePlayerEvent.ON_VIDEO_LOAD_REQUEST:
                this.#onVideoLoadRequest(event?.data?.paramsVO);
                break;
        }
    };
}
